import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { patchCreativeV2 } from "api/creative_v2_patch";
import { ID, CreativeGroupShortV2 } from "models";
import { createGroup } from "../helpers/createGroup";

export const useUpdateCreativeGroup = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (err: AxiosError) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      creativeId,
      group,
    }: {
      creativeId: ID;
      group: CreativeGroupShortV2;
    }) => {
      const groupId = await createGroup(group);
      const patchRes = await patchCreativeV2({
        id: creativeId,
        creative: { group: groupId },
      });
      return patchRes.data;
    },
    onSuccess,
    onError,
  });
};